import { OrgMember, UserKind } from '~/types'

// An agent member has no email, so it goes by the name it was approved with.
export const getMemberLabel = (member: OrgMember) =>
  member.kind === UserKind.Agent ? member.displayName : member.email

export const getMemberEventProperties = (member: OrgMember) =>
  member.kind === UserKind.Agent
    ? { agentUserId: member.id }
    : { email: member.email }
